import { render } from "./PayAccount.vue?vue&type=template&id=08b42679&scoped=true"
import script from "./PayAccount.vue?vue&type=script&lang=js"
export * from "./PayAccount.vue?vue&type=script&lang=js"

import "./PayAccount.vue?vue&type=style&index=0&id=08b42679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b42679"]])

export default __exports__